import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as content from "./style.module.scss";
export const Content = () => {
  return (
    <section className={`${content.content} ${main.sec}`}>
      <div className="container">
        <div className={`${main.blockTitle} ${main.blockTitleMdM} ${content.content_title}`}>
          Содержание курса
        </div>

        <div className={`row ${content.content_row} ${content.content_rowFirst}`}>
          <div className={`col col-4 ${content.content_col} ${content.content_nameBlock}`}>
            <div className={content.content_colName}>
              Теория
            </div>
          </div>
          <div className={`col col-2 ${content.content_col} ${content.content_colIcon_block} ${content.afterNone}`}>
            <div className={content.content_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/smart/03-theory.svg" alt="Теория"/>
            </div>
          </div>
          <div className={`col col-6 ${content.content_col} ${content.content_descBlock}`}>
            <div className={content.content_colNameMob}>
              Теория
            </div>
            <div className={content.content_colDesc}>
              Полная методика постановки цели по&nbsp;SMART
              в&nbsp;различных ситуациях на&nbsp;уровнях личности, команды
              и&nbsp;организации
            </div>
          </div>
        </div>

        <div className={`row ${content.content_row}`}>
          <div className={`col col-4 ${content.content_col} ${content.content_nameBlock}`}>
            <div className={content.content_colName}>
              Практика
            </div>
          </div>
          <div className={`col col-2 ${content.content_col} ${content.content_colIcon_block}`}>
            <div className={content.content_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/smart/03-practice.svg" alt="Практика"/>
            </div>
          </div>
          <div className={`col col-6 ${content.content_col} ${content.content_descBlock}`}>
            <div className={content.content_colNameMob}>
              Практика
            </div>
            <div className={content.content_colDesc}>
              Простые и&nbsp;понятные примеры: как&nbsp;применять методику
            </div>
          </div>
        </div>

        <div className={`row ${content.content_row}`}>
          <div className={`col col-4 ${content.content_col} ${content.content_nameBlock}`}>
            <div className={content.content_colName}>
              Упражнения
            </div>
          </div>
          <div className={`col col-2 ${content.content_col} ${content.content_colIcon_block}`}>
            <div className={content.content_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/smart/03-lesson.svg" alt="Упражнения"/>
            </div>
          </div>
          <div className={`col col-6 ${content.content_col} ${content.content_descBlock}`}>
            <div className={content.content_colNameMob}>
              Упражнения
            </div>
            <div className={content.content_colDesc}>
              Постановка цели и&nbsp;изолированная тренировка навыка
              с&nbsp;помощью тренажера: по&nbsp;каждому критерию
              и&nbsp;комплексно по&nbsp;всем пяти
            </div>
          </div>
        </div>

        <div className={`row ${content.content_row}`}>
          <div className={`col col-4 ${content.content_col} ${content.content_nameBlock}`}>
            <div className={content.content_colName}>
              Практические задания
            </div>
          </div>
          <div className={`col col-2 ${content.content_col} ${content.content_colIcon_block}`}>
            <div className={content.content_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/smart/03-practice2.svg" alt="Практика"/>
            </div>
          </div>
          <div className={`col col-6 ${content.content_col} ${content.content_descBlock}`}>
            <div className={content.content_colNameMob}>
              Практические задания
            </div>
            <div className={content.content_colDesc}>
              Оценка своих целей по&nbsp;различным критериям
            </div>
          </div>
        </div>

        <div className={`row ${content.content_row}`}>
          <div className={`col col-4 ${content.content_col} ${content.content_nameBlock}`}>
            <div className={content.content_colName}>
              Тесты
            </div>
          </div>
          <div className={`col col-2 ${content.content_col} ${content.content_colIcon_block}`}>
            <div className={content.content_colIcon}>
              <img src="https://fs.advance.ru/landing-pages/online/smart/03-test.svg" alt="Тесты"/>
            </div>
          </div>
          <div className={`col col-6 ${content.content_col} ${content.content_descBlock}`}>
            <div className={content.content_colNameMob}>
              Тесты
            </div>
            <div className={content.content_colDesc}>
              Закрепление и&nbsp;проверка новых знаний
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
